import React from 'react';

const RightArrow = () => {

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.45833 2.91666L13.5417 10L6.45833 17.0833" stroke="#55555F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default RightArrow;